const normalize = (text: string) =>
  text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

export const matchesName = (name: string, query: string) =>
  normalize(name).includes(normalize(query));
